/*
 *@description:  文字路演多视频播放模块
 *@modifyContent:
 *@author: qiuhongyang
 *@date: 2020-11-12 10:01:39
 *
*/

declare let emav: any;
import _ from "lodash";
let dot = require('dot')
let nosphtml = require('./tpl.html');

class ChangeVedios {
  boxid: string;
  data: Array<any>;
  currentplay: number = 0;
  totalnum: number = 0;
  scrollable: boolean = false;
  videoitem: any;
  emavid: string; //必传
  isEnded: boolean | undefined;
  status: number | string; // 直播状态
  constructor(opt: {
    emavid: string,
    boxid: string,
    data: any,
    status: any
  }) {
    this.boxid = opt.boxid;
    this.data = opt.data;  //视频源列表
    this.emavid = opt.emavid;
    this.status = opt.status;
  };
  init() {
    let that = this;
    let list: any = this.data;
    if (!list || list.length < 1) return false;

    this.renderHtml();
    let mediagroup0 = list?.[0]?.media_group?.[0] || []; //第一条数据

    let params = {
      src: mediagroup0?.media?.url || "",
      emavid: that.emavid || "",
      status: that.status
    };
    setTimeout(() => {
      this.initvideo(params, that.currentplay);
    }, 100);

    this.bindEvent();

    setTimeout(() => {
      this.changePosition();
    }, 1000);
  };
  initvideo(opt: any, currentplay: number) {
    let that = this;
    if (!opt.src) { return false };
    let defaultopt = {
      width: 650,
      height: 366,
      poster: "",
      env: "",
      muted: false,
      status: "",
      autoplay: false,
      bigPlayButton: true, //是否展示中间的播放按钮
      scalable: false, //滚动是否缩放小窗口
      emavid: ""
    };

    let options = $.extend({}, defaultopt, opt);
    // 如果直播则自动播放
    if (options.status == 1) {
      options.autoplay = true;
    };
    let videoitem = emav(that.emavid, {
      width: options.width,//播放器区域宽度，单位像素，按需设置，可通过 CSS 控制播放器尺寸。
      height: options.height,//播放器区域高度，单位像素，按需设置，可通过 CSS 控制播放器尺寸。
      controls: true,//是否显示播放器的控制栏，默认true
      poster: options.poster,//设置封面图片完整地址
      posterImage: true,//是否显示封面
      autoplay: options.autoplay,//是否自动播放，默认false
      useFWASFSApi: true,  //浏览器全屏
      loop: false,//是否循环播放，默认false
      muted: options.muted,//是否静音播放，默认false
      preload: 'auto',//是否需要预加载，有 3 个属性"auto"，"meta"，"none" ，移动端由于系统限制，设置 auto 无效。默认auto
      controlBar: {//设置控制栏属性的参数组合
        children: [
          "playToggle",
          "volumePanel"
        ],
        playToggle: true,//是否显示播放、暂停切换按钮
        volumePanel: true,//是否显示音量控制

        remainingTimeDisplay: false,//是否显示视频剩余时间
        currentTimeDisplay: true,//是否显示视频当前时间
        timeDivider: true,//是否显示时间分割符（/）
        durationDisplay: true,//是否显示视频时长

        progressControl: true,//是否显示播放进度条
        playbackRateMenuButton: true,
        fullscreenToggle: true//是否显示全屏按钮
      },
      pausedView: {  //暂停展示属性
        title: "",
        color: '',
        backgroundColor: "",
        fontSize: 1.8,
        fullscreenFontSize: 3.8
      },
      showContextMenu: false,//是否显示右键菜单，默认false
      showBigPlayButtonOnPaused: true,//暂停时是否显示播放按钮，默认false
      bigPlayButton: options.bigPlayButton,//是否显示居中的播放按钮
      isAudio: false,//是否为音频，默认false
      statistic: {
        activeTime: true
      },
      env: options.env//环境切换，默认为正式环境(production)，测试环境（env）需手动指定
    });

    that.videoitem = videoitem;

    if (options.autoplay) {
      videoitem.autoplay(true);
    };

    console.log(options.autoplay)

    let src = (opt.src).replace('http://', '//').replace('https://', '//')
    videoitem.src(src);

    that.playEvent(videoitem, currentplay);
  };
  renderHtml() {
    let data = this.data;
    let div = $("#" + this.boxid);
    // console.log(data)
    let innerhtml = dot.template(nosphtml)(data);
    div.empty().append($(innerhtml));

  };
  bindEvent() {
    let that = this;
    let totalnum = that.data.length;
    that.totalnum = totalnum;

    if (totalnum < 5) {
      $(".arrow").hide();
      $(".content").css({ "width": "660px", "margin": 0 })
    };

    $(".items-box").css({ "width": totalnum * 168 + "px" });

    $("#wz-video-wrap").on("click", ".items-box .item", function () {
      let src = $(this).data("src");
      let params = {
        src: src,
        autoplay: true
      }
      let currentplay = $(this).data("idx");
      that.currentplay = currentplay;
      that.videoitem.autoplay(true);
      that.initvideo(params, currentplay);

    });

    $("#wz-video-wrap").on("click", ".arrow", _.throttle(function (this: any) {
      if (totalnum < 4) return false;

      let $html = $(this);

      let ml = Number(($(".items-box").css('marginLeft')).replace("px", ""));
      if ($html.hasClass("arrow-right")) {
        if (ml < (-165 * (totalnum - 3))) return;
        $(".items-box").animate({ "margin-left": (-165 + ml) + "px" }, 500);
      };

      if ($html.hasClass("arrow-left")) {
        if (!(ml < 0)) return;
        $(".items-box").animate({ "margin-left": (165 + ml) + "px" }, 500);
      };
    }, 600));

    $("#lysmallvedio").on("click", ".close-emav-icon", function () {
      // $("#wz-video-wrap").find(".emav").removeClass("emav-scroll");
      $("#lysmallvedio").find(".emav").removeClass("emav-scroll2");
      $("#wz-video-wrap").append($("#lysmallvedio").children("div:first"))
      that.scrollable = false;
      that.removeCloseLab();
    })
  };

  playEvent(videoitem: any, currentplay: number) {
    var that = this;
    videoitem.on('play', function (e: any) {
      that.addActiveClass(currentplay);
      that.scrollable = true;
      that.isEnded = false;
    });
    videoitem.on('ended', function (e: any) {
      that.scrollable = false;
      that.isEnded = true;
      if (that.currentplay + 1 > that.totalnum || that.currentplay + 1 == that.totalnum) {
        return
      };
      $(".items-box").find(".item").eq(currentplay + 1).trigger("click");
    });
  };

  addActiveClass(eq: number) {
    let curitem = $(".items-box").find(".item").eq(eq);
    curitem.find(".txt").addClass("onitem");
    curitem.siblings().find(".txt").removeClass("onitem");
  };

  addCloseLab() {
    $(".close-emav-icon").show();
  };

  removeCloseLab() {
    $(".close-emav-icon").hide();
  };

  changePosition() {
    try {
      let that = this;
      let closeele = $('<span class="close-emav-icon"></span>');
      $("#wz-video-wrap .emav").append(closeele);

      $(window).scroll(_.debounce(function () {

        //是否有小视频
        let hassmall = $("#lysmallvedio").children(".wz-video-box")?.length;
        if (hassmall) {
          that.scrollable = true;
        };

        if (!hassmall && that.isEnded) {
          $("#wz-video-wrap").find(".emav").removeClass("emav-scroll2");
          return false;
        };

        if (!that.scrollable) return false;

        let scrolltop: any = $(document).scrollTop();
        let vediowrap: any = $("#wz-video-wrap").offset();
        let offsettop = vediowrap.top;
        let _h: any = $("#vedioCtrlBox").height();  //#wz-video-wrap
        if (scrolltop - offsettop - _h > 50) {
          //小视频
          that.addCloseLab();
          // $("#wz-video-wrap").find(".emav").addClass("emav-scroll"); 
          $("#wz-video-wrap").find(".emav").addClass("emav-scroll2");
          $("#lysmallvedio").append($("#wz-video-wrap").children("div:first"));
          $("#lysmallvedio").show();

        } else {
          //大视频
          that.removeCloseLab();
          // $("#wz-video-wrap").find(".emav").removeClass("emav-scroll");
          $("#wz-video-wrap").find(".emav").removeClass("emav-scroll2");
          $("#wz-video-wrap").append($("#lysmallvedio").children("div:first"))
          $("#lysmallvedio").hide();
        }

      }, 10));
    } catch (error) {

    }
  };
}


export default ChangeVedios;